module.exports = __webpack_public_path__ + "img/pagsmile-color.b9402df.png";